<form [formGroup]="terminalForm" (ngSubmit)="onSubmit()" class="create-payment-terminal-form">
    @if (isProcessing) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    <div class="form-section">
        <div class="form-row">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Terminal Name</mat-label>
                <input matInput required formControlName="deviceName" placeholder="e.g., Medicent Pay Column"
                    [maxlength]="maxNameLength">
                <mat-icon matSuffix>point_of_sale</mat-icon>
                @if (terminalForm.get('deviceName')?.hasError('required')) {
                <mat-error>Terminal name is required</mat-error>
                }
                @if (terminalForm.get('deviceName')?.hasError('minlength')) {
                <mat-error>Terminal name must be at least 2 characters</mat-error>
                }
            </mat-form-field>
        </div>

        <div class="form-row two-col">
            <mat-form-field appearance="fill">
                <mat-label>Provider</mat-label>
                <mat-select formControlName="providerKind">
                    @for (kind of providerKinds; track kind) {
                    <mat-option [value]="kind">{{ kind }}</mat-option>
                    }
                </mat-select>
                <mat-hint>IM30 self-service column, or Card terminal (Valina exit lane)</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="fill">
                <mat-label>Driver</mat-label>
                <mat-select formControlName="driverKind">
                    @for (kind of driverKinds; track kind) {
                    <mat-option [value]="kind">{{ kind }}</mat-option>
                    }
                </mat-select>
                <mat-hint>ZVT for Valina + IM30 stations (the Pi speaks ZVT)</mat-hint>
            </mat-form-field>
        </div>

        <div class="form-row two-col">
            <mat-form-field appearance="fill">
                <mat-label>Provider Terminal ID</mat-label>
                <input matInput required formControlName="providerTerminalId" placeholder="e.g., 00003010"
                    [maxlength]="maxProviderTerminalIdLength">
                <mat-icon matSuffix>tag</mat-icon>
                @if (terminalForm.get('providerTerminalId')?.hasError('required')) {
                <mat-error>Provider Terminal ID is required</mat-error>
                }
                <mat-hint>The EMV / provider-side terminal id</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="fill">
                <mat-label>Location Code</mat-label>
                <input matInput required formControlName="locationCode" placeholder="e.g., medicent"
                    [maxlength]="maxLocationCodeLength">
                <mat-icon matSuffix>place</mat-icon>
                @if (terminalForm.get('locationCode')?.hasError('required')) {
                <mat-error>Location Code is required</mat-error>
                }
                <mat-hint>Site code reported by the terminal</mat-hint>
            </mat-form-field>
        </div>

        @if (isZvt) {
        <div class="form-row two-col">
            <mat-form-field appearance="fill">
                <mat-label>ZVT Reader Host</mat-label>
                <input matInput required formControlName="zvtHost" placeholder="e.g., 192.168.1.50"
                    [maxlength]="maxZvtHostLength">
                <mat-icon matSuffix>lan</mat-icon>
                @if (terminalForm.get('zvtHost')?.hasError('required')) {
                <mat-error>ZVT host is required for a ZVT terminal</mat-error>
                }
                <mat-hint>IP of the card reader on the station LAN (kiosk-local, never WAN)</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="fill">
                <mat-label>ZVT Reader Port</mat-label>
                <input matInput required type="number" formControlName="zvtPort" placeholder="20007">
                <mat-icon matSuffix>settings_ethernet</mat-icon>
                @if (terminalForm.get('zvtPort')?.hasError('required')) {
                <mat-error>ZVT port is required (conventionally 20007)</mat-error>
                }
                @if (terminalForm.get('zvtPort')?.hasError('min') || terminalForm.get('zvtPort')?.hasError('max')) {
                <mat-error>Port must be between 1 and 65535</mat-error>
                }
                <mat-hint>Conventionally 20007</mat-hint>
            </mat-form-field>
        </div>
        }

        <div class="form-row">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Description</mat-label>
                <textarea matInput formControlName="deviceDescription" placeholder="Optional description"
                    rows="2" [maxlength]="maxDescriptionLength"></textarea>
                <mat-icon matSuffix>note</mat-icon>
                <mat-hint>Optional</mat-hint>
            </mat-form-field>
        </div>
    </div>

    <div class="form-actions">
        <button mat-raised-button color="accent" type="submit" [disabled]="terminalForm.invalid || isProcessing">
            <mat-icon>save</mat-icon>
            {{ isEdit ? 'Save Changes' : 'Create Payment Terminal' }}
        </button>
        <button mat-button type="button" (click)="onCancel()" [disabled]="isProcessing">
            Cancel
        </button>
    </div>
</form>
